import React from "react";
import { Link } from "react-router-dom";
import LoadingNumber from "./LoadingNumber";
import { pad2 } from "../lib/results";

/**
 * Yesterday / today numbers for every game.
 *
 * Each game name links to its own result page — this is the main internal
 * link path from the highest-authority page on the site to the long-tail ones.
 */
const LiveResultsTable = ({ rows, isLoading, error }) => (
  <>
    {error && (
      <div className="error-box small" style={{ marginBottom: 8 }}>
        {error}
      </div>
    )}

    <div className="table-wrap">
      <table className="results-table">
        <thead>
          <tr>
            <th scope="col">Game</th>
            <th scope="col">Yesterday</th>
            <th scope="col">Today</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => {
            const rowClass = idx % 2 === 0 ? "row-odd" : "row-even";
            const showToday = row.today != null && row.shouldShowToday;

            return (
              <tr key={row.game.key} className={rowClass}>
                <th scope="row" className="game-name game-left">
                  <Link to={`/${row.game.slug}`} className="game-link">
                    {row.game.name}
                  </Link>
                  <span className="game-time">{row.game.timeLabel}</span>
                </th>
                <td>
                  {row.yesterday != null ? (
                    <span className="large">{pad2(row.yesterday)}</span>
                  ) : isLoading ? (
                    <LoadingNumber />
                  ) : (
                    <span className="xx-placeholder">XX</span>
                  )}
                </td>
                <td>
                  {showToday ? (
                    <span className="large">{pad2(row.today)}</span>
                  ) : isLoading ? (
                    <LoadingNumber />
                  ) : (
                    <span className="xx-placeholder">XX</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </>
);

export default LiveResultsTable;
